import { ConfigProvider, Tabs } from 'antd'

import type { TabsProps } from 'antd'

export interface TadTabItem {
  label: string
  key: string
  disabled?: boolean
  icon?: React.ReactNode
}

export interface TadTabsProps {
  /** Tab 项目列表 */
  items: TadTabItem[]
  /** 当前激活的 tab key */
  activeKey?: string
  /** 默认激活的 tab key */
  defaultActiveKey?: string
  /** Tab 切换回调函数 */
  onChange?: (activeKey: string) => void
  /** 自定义样式类名 */
  className?: string
  /** Tab 尺寸 */
  size?: TabsProps['size']
  /** 是否禁用 */
  disabled?: boolean
  /** 加载状态 */
  loading?: boolean
  /** Tab 类型 */
  type?: TabsProps['type']
  /** 自定义主题配置 */
  themeConfig?: {
    itemActiveColor?: string
    itemHoverColor?: string
    inkBarColor?: string
    itemSelectedColor?: string
    horizontalItemGutter?: number
  }
}

const defaultThemeConfig = {
  itemActiveColor: '#FFFFFF',
  itemHoverColor: '#FFFFFF',
  inkBarColor: '#FFFFFF',
  itemSelectedColor: '#FFFFFF',
  horizontalItemGutter: 16,
}

const TadTabs: React.FC<TadTabsProps> = ({
  items,
  activeKey,
  defaultActiveKey,
  onChange,
  className,
  size = 'small',
  disabled = false,
  loading = false,
  type = 'line',
  themeConfig = defaultThemeConfig,
  ...restProps
}) => {
  const handleChange = (key: string) => {
    // 调用外部传入的 onChange 回调
    onChange?.(key)
  }

  const tabsClassName = `
    [&_.coco-tabs-tab]:text-f-text-tertiary
    [&_.coco-tabs-tab-active]:text-f-text 
    [&_.coco-tabs-nav]:!mb-0
    [&_.coco-tabs-nav]:before:!content-none
    ${className || ''}
  `

  const tabsContent = (
    <Tabs
      className={tabsClassName}
      type={type}
      items={items.map((item) => ({
        ...item,
        disabled: disabled || item.disabled,
      }))}
      size={size}
      activeKey={activeKey}
      defaultActiveKey={defaultActiveKey}
      onChange={handleChange}
      {...restProps}
    />
  )

  const themedTabs = (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            ...defaultThemeConfig,
            ...themeConfig,
          },
        },
      }}
    >
      {tabsContent}
    </ConfigProvider>
  )

  // 直接返回 themedTabs，让外部决定是否用 Form.Item 包装
  return themedTabs
}

export default TadTabs
